const APP = {
  BREADCRUMB_FIRST_ITEM: 'Promoções',
  CATEGORIES: 'Categorias',
  CTX_OPTIONAL_PROPS: '__app-ctx-optional-props',
  DEFAULT_LOCALE: 'pt_BR',
  DESCRIPTION:
    'Encontre as Melhores Ofertas e Cupons no Promobit. Reunimos promoções de Smartphones, TVs, Moda e muito mais. O menor preço nas melhores lojas.',
  DESCRIPTION_SHORT: 'Promobit, encontre as melhores promoções.',
  GOOGLE_AD_MANAGER_URL: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
  GOOGLE_TAG_MANAGER_URL: 'https://www.googletagmanager.com/gtag/js',
  MOUSEFLOW_URL: '//cdn.mouseflow.com/projects/',
  LOCAL_IMAGE_PATH: '/dist/images',
  NAME: 'Promobit',
  OG_TITLE: 'As melhores promoções, só aqui no Promobit.',
  REMOTE_IMAGE_PATH: 'https://i.promobit.com.br',
  TITLE: 'As Melhores Ofertas | Promoções e Cupons é no Promobit',
  URL: 'https://www.promobit.com.br',
};

export default APP;
